module.exports = __webpack_public_path__ + "static/media/picture-(287).ee33fc16.JPG";